import { retirarPwa } from './retiro/retiroPwa';

/**
 * Unico script de la portada. NO monta ninguna app: la pagina ya llega completa desde el HTML.
 *
 * Solo da de baja, si existe, lo que dejo la PWA retirada (service worker + caches). Sin `await` y
 * con `void`: `retirarPwa` nunca lanza, y la portada no debe esperar ni condicionarse a la limpieza.
 * Ver `retiro/retiroPwa.ts` y `public/sw.js`. Este archivo NO registra ningun service worker: el
 * `sw.js` publicado es un kill-switch que se da de baja solo, no una funcionalidad (lo vigila
 * `portada.spec.ts`).
 */
void retirarPwa({
  serviceWorker: 'serviceWorker' in navigator ? navigator.serviceWorker : undefined,
  caches: 'caches' in globalThis ? globalThis.caches : undefined,
});
